export const ADMIN = "ADMIN"
export const SUPER = "SUPER"
export const SUPPORT = "SUPPORT"
export const TEACHER = "TEACHER"
